// Relative imports (not `@/`) so bun can test this module.
import type { EntityId, SimState } from '../sim';

/** One attack target of the selection and the selected own units going for it. */
export interface FocusTarget {
  targetId: EntityId;
  attackerIds: EntityId[];
}

/**
 * The attack targets of the selected own units (`attack` orders), one entry
 * per distinct target in the order they're first reached through
 * `selectedUnitIds`. Targets (units or buildings) missing from `state` are
 * skipped; whether a target is in sight is left to the caller.
 */
export function focusTargets(
  state: SimState,
  selectedUnitIds: readonly EntityId[],
  playerId: string
): FocusTarget[] {
  const byTarget = new Map<EntityId, FocusTarget>();
  for (const id of selectedUnitIds) {
    const unit = state.units[id];
    if (!unit || unit.owner !== playerId || unit.order?.kind !== 'attack') continue;
    const { targetId } = unit.order;
    if (!state.units[targetId] && !state.buildings[targetId]) continue;
    const entry = byTarget.get(targetId);
    if (entry) entry.attackerIds.push(id);
    else byTarget.set(targetId, { targetId, attackerIds: [id] });
  }
  return [...byTarget.values()];
}
